module.exports = __webpack_public_path__ + "static/img/rules-bg.d8dfc80e.png";